import React, {Fragment} from 'react';
import ReactDOM from 'react-dom';
import Puzzle from 'react-image-puzzle';
//import MemoryClass from "./memoryClass";
import axios from 'axios';

const ASSETS_BASE = /localhost/.test(window.location.href) ? "" : "/global17/bundles/games/dist";


class Card extends React.Component {
	constructor(props) {
		super(props)
		this.state = { }
	}
	clicked(framework){
		this.props.click(framework)
	}
	render(){
		return (
			<div className={"card" + (!this.props.close ? ' opened' : '') + (this.props.complete ? ' matched' : '')} onClick={() => this.clicked(this.props.framework)}>
				<div className="front">
					?
				</div>
				<div className="back">
					<img src={"https://raw.githubusercontent.com/samiheikki/javascript-guessing-game/master/static/logos/" + this.props.framework + ".png"}/>
				</div>
			</div>
		)
	}
}



//CLASSE MEMORY GAME
class MemoryClass extends React.Component{

	constructor(props) {
		super(props)
		this.state = {
			remainingTime:   120,
			started: false,
			ended: false,
			img:   "",
			visible: true,
			frameworks: [ 'yarn','nodejs','grunt','npm' ],
			duplicatedFrameworks: [],
			randomizedFrameworks: [],
			finalizedFrameworks: [],
			openedFrameworks: []
		}
		//bind methods
		this.endgame 		= this.endgame.bind(this);
		this.startTimer 		= this.startTimer.bind(this);


		this.start()
	}
	componentDidMount() {
		this.startTimer()
	}


	handleClick(name,index) {
		if(this.state.openedFrameworks.length == 2){
			setTimeout(() => {
				this.check()
			},750)
		} else {
			let framework = {
				name,
				index
			}
			let finalizedFrameworks = this.state.finalizedFrameworks
			let frameworks = this.state.openedFrameworks
			finalizedFrameworks[index].close = false
			frameworks.push(framework)
			this.setState({
				openedFrameworks: frameworks,
				finalizedFrameworks: finalizedFrameworks
			})
			if(this.state.openedFrameworks.length == 2){
				setTimeout(() => {
					this.check()
				},750)
			}
		}
	}
	check(){
		let finalizedFrameworks = this.state.finalizedFrameworks
		if((this.state.openedFrameworks[0].name == this.state.openedFrameworks[1].name) && (this.state.openedFrameworks[0].index != this.state.openedFrameworks[1].index)){
			finalizedFrameworks[this.state.openedFrameworks[0].index].complete = true
			finalizedFrameworks[this.state.openedFrameworks[1].index].complete = true

		}else {
			finalizedFrameworks[this.state.openedFrameworks[0].index].close = true
			finalizedFrameworks[this.state.openedFrameworks[1].index].close = true

		}
		this.setState({
			finalizedFrameworks,
			openedFrameworks: []
		})

		this.endgame( () => {
			this.setState({
				visible:false
			})
		});
	}
	end(win = false) {
		if(win)
			console.log("Winner!");
		else
			console.log("Loser!");
	}

	//check a fine game
	endgame( callback ){
		let countMatch = 0;
		this.state.finalizedFrameworks.map( (item ) =>{
			if( item.complete ){
				countMatch++;
			}
		});
		if( countMatch == this.state.finalizedFrameworks.length ){
			callback();
		}

	}
	startTimer() {
		this.setState({started: true}, () => {
			setInterval(() => {
				if(this.state.started && !this.state.ended)
					if(this.state.remainingTime === 1)
						this.setState({
							remainingTime: this.state.remainingTime - 1,
							started: true,
							ended:   true
						}, () => {
							this.end();
						});
					else
						this.setState({
							remainingTime: this.state.remainingTime - 1
						});
			}, 1000);
		});
	}
	start(){
		let finalizedFrameworks = [];
		this.state.duplicatedFrameworks = this.state.frameworks.concat(this.state.frameworks)
		this.state.randomizedFrameworks = this.shuffle(this.state.duplicatedFrameworks)
		this.state.randomizedFrameworks.map((name,index) => {
			finalizedFrameworks.push({
				name,
				close: true,
				complete: false,
				fail: false
			})
		})
		this.state.finalizedFrameworks = finalizedFrameworks
	}
	shuffle(array){
		let currentIndex = array.length, temporaryValue, randomIndex;
		while (0 !== currentIndex) {
			randomIndex = Math.floor(Math.random() * currentIndex);
			currentIndex -= 1;
			temporaryValue = array[currentIndex];
			array[currentIndex] = array[randomIndex];
			array[randomIndex]  = temporaryValue;
		}
		return array
	}
	render(){
		const { remainingTime, started, maxClicks, remainingClicks, differences, spottedDifferences, img1, img2 } = this.state;

		return (
			<div>

				<div className={"header"}>
					<div className={"container"}>
						<div className={"logo"}>{/*Logo purina*/}</div>
						<div className={"flex j-center a-center"}>
							<div className={"time flex j-center a-center"}>
								<img className={"time-icon"} src={ASSETS_BASE + "/images/time.png"} />
								<span className={"time-remaining"}>
									TEMPO RESIDUO <strong><Timer started={started} remainingTime={remainingTime} /></strong>
 								</span>
							</div>
						</div>
						<div className={"time flex j-center a-center"}>
							<h1> GAME MEMORY 111</h1>
						</div>
					</div>
				</div>

				<div className={"game-canvas"}>
					<div className={"container"}>
						{ this.state.visible  ? (
							<div className="playground">
								{
									this.state.finalizedFrameworks.map((framework, index) => {
										return <Card key={index} framework={framework.name} click={() => {
											this.handleClick(framework.name,index)}} close={framework.close} complete={framework.complete}/>
									})
								}
							</div>
						) : (
							<div className={"win_block"}>
								Complimenti hai vinto!
								Ecco il tuo codice sconto [  i9s9di9m38i9i ]
							</div>
						)}

					</div>
				</div>

			</div>
		)
	}
}

const Timer = ({ remainingTime }) => {
	const mins = Math.floor(remainingTime/60) < 10 ? `0${Math.floor(remainingTime/60)}` : Math.floor(remainingTime/60);
	const secs = (remainingTime%60) < 10 ? `0${(remainingTime%60)}` : (remainingTime%60);
	return (
		<Fragment>
			{mins}:{secs}
		</Fragment>
	);
}

document.addEventListener("DOMContentLoaded", () => {
	const mountPoint = document.getElementById("memory-game-canvas");
	if(mountPoint)
		ReactDOM.render(<MemoryClass />, mountPoint);
});
